import {
  DAMLIST,
} from 'actions/dam';
import {reducerPackage} from "../../utils";

export const damList = reducerPackage(DAMLIST);
